import {type} from 'arktype'

import {paginatedResponseData, responseData} from '@/lib/api/ResponseData'

// export const ReferenceType = {
//   order_tb: 'order_tb', // the order record causing the balance changes.
//   booking: 'booking', // the booking record causing the balance changes.
//   food_order: 'food_order', // the food order record causing the balance changes.
//   reward: 'reward', // the reward record causing the balance changes.
//   operator: 'operator', // the Innosearch operator causing the balance changes.
// } as const
// export type ReferenceType = (typeof ReferenceType)[keyof typeof ReferenceType]

const Reward = type({
  id: 'string',
  walletId: 'string',
  amount: 'string.numeric',
  description: 'string?',
  balanceAfter: 'string.numeric',
  // referenceType: type.enumerated(...Object.values(ReferenceType)),
  referenceId: 'string',
  createdAt: 'string.date.iso.parse',
  updatedAt: 'string.date.iso.parse',
  createdBy: 'string',
  updatedBy: 'string',
})
export type RawReward = typeof Reward.inferIn
export type Reward = typeof Reward.infer

export const RewardResponse = responseData(Reward)
export type RewardResponse = typeof RewardResponse.infer

export const PaginatedRewardResponse = paginatedResponseData(Reward)
export type PaginatedRewardResponse = typeof PaginatedRewardResponse.infer
